<template>
  <div>
    <PageAllow controller="SubAccountSettings" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherKeyword
                ref="keyword"
                v-model="keyword"
                @text="KeywordText($event)"
                :label="$t('AccountAds.select')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <!-- 新增按钮 -->
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click="
                  editDialog = true;
                  type = '';
                  currentItem = { require: '0' };
                  mode = 'new';
                "
                v-if="$permission.permissionAllow('SubAccountSettings', 'add')"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("AccountAds.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="settingItems"
          :loading="loading"
          :options.sync="options"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.require="{ item }">
            {{ item.require | requireTypesText }}
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- 编辑按钮 -->
            <v-tooltip
              top
              v-if="$permission.permissionAllow('SubAccountSettings', 'edit')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    editDialog = true;
                    type = item.type;
                    currentItem = JSON.parse(JSON.stringify(item));
                    mode = 'edit';
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("AccountAds.actions.edit") }}
                </v-btn>
              </template>
              <span>{{ $t("AccountAds.actions.edit") }}</span>
            </v-tooltip>
            <!-- 删除按钮 -->
            <v-tooltip
              top
              v-if="$permission.permissionAllow('SubAccountSettings', 'delete')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    delDialog = true;
                    currentItem = JSON.parse(JSON.stringify(item));
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("AccountAds.actions.delete") }}
                </v-btn>
              </template>
              <span>{{ $t("AccountAds.actions.delete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog v-model="delDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="delDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("AccountAds.del_text") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="delDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="Del()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 编辑、新增按钮 -->
    <v-dialog v-model="editDialog" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("SubAccountSettings.Fields.type_info") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <!-- <ValidationObserver ref="observer"> -->
          <v-container>
            <!-- 类型 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccountSettings.Fields.type") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  v-model="currentItem.type"
                  :disabled="mode == 'edit'"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!--名称 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccountSettings.Fields.name") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="currentItem.name">
                </v-text-field>
              </v-col>
            </v-row>
            <!-- 是否必选 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SubAccountSettings.Fields.require") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="currentItem.require">
                  <v-radio
                    v-for="stat in typeRequireItems"
                    :key="stat.value"
                    :label="`${stat.text}`"
                    :value="stat.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="editDialog = false">
            {{ $t("SubAccountSettings.Fields.cancel") }}
          </v-btn>
          <v-btn color="primary" depressed @click="submit()">
            {{ $t("SubAccountSettings.Fields.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Consts from "@/consts.js";
import Breadcrumbs from "@/components/Breadcrumbs";
import SubAccountSettings from "@/api/sub_account_settings";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Required from "@/components/plugins/Required";

const defaultOptions = {
  keyword: "",
};

export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},

    sub_account_settings: {},
    sub_account_settingItems: [],
    currentItem: {},
    delDialog: false,
    editDialog: false,
    mode: "",
    type: "",
    keyword: "",
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    Required,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.subAccountSettings"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-type",
      },
      {
        text: i18n.t("SettingNav.subAccountType"),
        disabled: true,
        href: "/settings/sub-account-settings/sub-account-type",
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("SubAccountSettings.Fields.type"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("SubAccountSettings.Fields.name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("SubAccountSettings.Fields.require"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "require",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      ];
    },

    typeRequireItems() {
      return Consts.subAccountSettings.require_types;
    },
    settingItems() {
      return this.abc();
    },
    ...mapState(["loading", "stickTableCols"]),
  },

  mounted() {
    this.getAccountAdsFromAPI();
  },

  methods: {
    abc() {
      return this.sub_account_settingItems.filter(
        (e) =>
          (this.keyword && e.name.indexOf(this.keyword) > -1) ||
          e.type.indexOf(this.keyword) > -1 ||
          !this.keyword
      );
    },
    onSearch() {
      this.abc();
    },
    resetSearch() {
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    KeywordText(e) {
      this.keyword = e;
    },
    getAccountAdsFromAPI() {
      SubAccountSettings.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.sub_account_settings = response.data.sub_account_settings;
            var settingItems = [];
            for (let key in this.sub_account_settings) {
              settingItems.push(
                Object.assign({}, this.sub_account_settings[key], {
                  type: key,
                })
              );
            }
            this.sub_account_settingItems = settingItems;
          }
        }.bind(this)
      );
    },

    Del() {
      SubAccountSettings.del(this.currentItem.type).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAccountAdsFromAPI();
          }
          this.delDialog = false;
        }.bind(this)
      );
    },
    submit() {
      SubAccountSettings.save(this.type, this.currentItem).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getAccountAdsFromAPI();
            this.editDialog = false;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    
    // options: {
    //   deep: true,
    //   handler() {
    //     this.getAccountAdsFromAPI();
    //   },
    // },

    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    sub_account_settings: {
      handler() {},
    },
  },
};
</script>

<style>
</style>